import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: "지역" }, { name: "급" }, { name: getFieldLabel() }, { name: "예비조사 물질" }, { name: "본조사 제외 사유" }, { name: "재측정항목" }, { name: "조사일" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).inputA_1; // 지역
      case 1:
        return func.getContent(value).inputA_2; // 급
      case 2:
        return func.getContent(value).stdInfo.field_name; // 학교(기관)명
      case 3:
        return func.getContent(value).inputB_1; // 예비조사 물질
      case 4:
        return func.getContent(value).inputB_2; // 본조사 제외 사유
      case 5:
        return func.getContent(value).inputC_8; // 재측정항목
      case 6:
        return func.getContent(value).inputA_3; // 조사일
      case 7:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 8:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'content$body.inputA_3'
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case "지역":
      return ["content$body.inputA_1*%[:default_skw]%"];
    case "급":
      return ["content$body.inputA_2*%[:default_skw]%"];
    case getFieldLabel():
      return ["content$body.stdInfo.field_name*%[:default_skw]%"];
    case "예비조사 물질":
      return ["content$body.inputB_1*%[:default_skw]%"];
    case "본조사 제외 사유":
      return ["content$body.inputB_2*%[:default_skw]%"];
    case "재측정항목":
      return ["content$body.inputC_8*%[:default_skw]%"];
    case "조사일":
      return ["content$body.inputA_3*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }
    return [];
  },
};
